export default __webpack_public_path__ + "static/media/user.a94a0d8f.svg";